import { useHistory } from 'react-router-dom'
import { useGetBusinessIDIfExists } from '@marketing-milk/frontend'

export function useSwitchBusiness() {
  const history = useHistory()
  const businessID = useGetBusinessIDIfExists()

  return (nextBusinessID: number) => {
    // Swapping business keeps the user on the same kind of page rather than
    // dumping them back at a list. With no business yet there is no page to keep,
    // so land where the business list's own links do.
    if (!businessID) {
      history.push(`/${nextBusinessID}/campaigns`)
      return
    }
    history.push(history.location.pathname.replace(`/${businessID}/`, `/${nextBusinessID}/`))
  }
}
